<template>
    <div>
        <div class="box-question-group" v-for="(item,index) in exerciseType">
<!--            <h4 style="display: flex">-->
<!--                <div class="el-input" style="width: 150px;"><input type="text" @change="editName" v-model="item.itemName" autocomplete="off" placeholder="请输入内容" class="el-input__inner">-->
<!--                </div>-->
<!--                <span class="now_q_type"></span>-->
<!--                <button type="button" class="el-button btn el-button&#45;&#45;primary" @click="startDialog(index,item.exerciseType)"><span>添加试题</span></button>-->
<!--            </h4>-->
            <div class="hending">{{item.itemName}}</div>
            <div class="box-question" v-for="(item1,index1) in item.list" v-if="item.list.length > 0">
                <div>
                    <div class="el-row" style="display: flex;justify-content: space-between">
                        <div style="flex: 1;">
                            <div class="question">
                                <div class="testpaper-question-seq-wrap">
                                    <div class="testpaper-question-seq" style="position: relative;top: -3.5px">
                                        {{item1.seq}}
                                    </div>
                                    <div class="testpaper-question-score" style="position: relative;top: -3.5px">
                                        {{item.everyScore}}分
                                    </div>
                                </div>
                                <div class="testpaper-question-stem" v-html="item1.exercise.exerciseName">

                                </div>
                                <ul class="testpaper-question-choices js-testpaper-question-list" v-if="item.exerciseType == 1 || item.exerciseType == 2">
                                    <li class=" testpaper-question-body-item testpaper-question-choice-item" style="display: flex" v-for="(item2,index2) in item1.exercise.choices">
                                        <span class="testpaper-question-body-item__index">{{item2.option}}.</span><span style="margin-left: 8px" v-html="item2.optionContent"></span>
                                    </li>
<!--                                    <li class=" testpaper-question-body-item testpaper-question-choice-item">-->
<!--                                        <span class="testpaper-question-body-item__index">B.</span>B．大众媒介关注近代科技的应用-->
<!--                                    </li>-->
<!--                                    <li class=" testpaper-question-body-item testpaper-question-choice-item">-->
<!--                                        <span class="testpaper-question-body-item__index">C.</span>C．维新思想推动社会经济的发展-->
<!--                                    </li>-->
<!--                                    <li class=" testpaper-question-body-item testpaper-question-choice-item">-->
<!--                                        <span class="testpaper-question-body-item__index">D.</span>D．西方科学思想在中国得到弘扬-->
<!--                                    </li>-->
                                </ul>
                                <ul class="testpaper-question-choices js-testpaper-question-list" v-if="item.exerciseType == 3">
                                    <li class=" testpaper-question-body-item testpaper-question-choice-item">
                                        <span class="testpaper-question-body-item__index">A.</span>正确
                                    </li>
                                    <li class=" testpaper-question-body-item testpaper-question-choice-item">
                                        <span class="testpaper-question-body-item__index">B.</span>错误
                                    </li>
                                </ul>
                                <ul class="testpaper-question-choices js-testpaper-question-list" v-for="(item2,index2) in item1.exercise.fillblanks" v-if="item.exerciseType == 4">
                                    <li class=" testpaper-question-body-item testpaper-question-choice-item">
                                        <span class="testpaper-question-body-item__index">{{item2.fillSeq}}.</span><span style="margin-left: 8px" v-html="item2.fillContent"></span>
                                    </li>
                                </ul>
                                <div class="testpaper-question-footer clearfix">
                                    <div class="testpaper-question-result" v-if="item.exerciseType == 1 || item.exerciseType == 2">
                                        正确答案是 <strong class="color-success" v-html="item1.exercise.answer"></strong>
                                    </div>
                                    <div class="testpaper-question-result" v-if="item.exerciseType == 3">
                                        正确答案是 <strong class="color-success">{{item1.exercise.judge.judge === 1 ? 'A' : 'B'}}</strong>
                                    </div>
                                    <div class="testpaper-question-actions pull-right mts">
                                        <span class="view-toggle js-analysis-toggle">
                                            <a class="btn link-gray view-show js-analysis" @click="openJx(index,index1)">{{item1.isOpen ? '收起解析' : '展开解析'}}</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="testpaper-question-1153 js-testpaper-question-analysis" style="display: block;margin-left: 50px" v-if="item1.isOpen">
                                <div class="well mb0" v-html="item1.exercise.analysis">
                                </div>
                            </div>


<!--                            <div class="questionbody">-->
<!--                                <div class="questionNo">{{item1.seq}}.</div>-->
<!--                                <p v-html="item1.exercise.exerciseName">-->

<!--                                </p>-->
<!--                            </div>-->
<!--                            <div v-if="item.exerciseType == 1 || item.exerciseType == 2">-->
<!--                                <template v-for="(item2,index2) in item1.exercise.choices">-->
<!--                                    <span :class="item2.isAnswer === 1 ? 'active' : ''">{{item2.option}}:{{item2.optionContent}}</span>-->
<!--                                    <br>-->
<!--                                </template>-->
<!--                            </div>-->
<!--                            <div v-if="item.exerciseType == 3">-->
<!--                                <span :class="item1.exercise.judge.judge === 1 ? 'active' : ''">A:正确</span>-->
<!--                                <br>-->
<!--                                <span :class="item1.exercise.judge.judge === 0 ? 'active' : ''">B:错误</span>-->
<!--                            </div>-->
<!--                            <div v-if="item.exerciseType == 4">-->
<!--                                <template v-for="(item2,index2) in item1.exercise.fillblanks">-->
<!--                                    <span class="" >{{item2.fillSeq}}:{{item2.fillContent}}</span>-->
<!--                                    <br>-->
<!--                                </template>-->
<!--                            </div>-->
<!--                            <template v-if="item.exerciseType == 1 || item.exerciseType == 2 || item.exerciseType == 3">-->
<!--                                <div class="questionNo">答案：-->
<!--                                </div>-->
<!--                                <p v-if="item.exerciseType == 1 || item.exerciseType == 2">{{item1.exercise.answer}}</p>-->
<!--                                <p v-if="item.exerciseType == 3">{{item1.exercise.judge.judge === 1 ? '正确' : '错误'}}</p>-->
<!--                            </template>-->
<!--                            <div class="questionNo">解析：</div>-->
<!--                            <p v-html="item1.exercise.analysis"></p>-->
                        </div>
                        <div class="edit-btn" style="text-align: right;width: 80px;flex-shrink: 0;padding-top: 8px">
                            <div class="edit-icon" style="margin: 0 !important;">
                                <a class="el-link el-link--primary" style="font-size: 18px; margin-left: 5px;">
                                    <span class="el-link--inner" @click="updateRows('delete',index,index1)"><i class="el-icon-delete"></i></span>
                                </a>
                                <a class="el-link el-link--primary" style="font-size: 18px; margin-left: 5px;">
                                    <span class="el-link--inner" @click="updateRows('up',index,index1)"><i class="el-icon-top"></i></span>
                                </a>
                                <a class="el-link el-link--primary" style="font-size: 18px; margin-left: 5px;">
                                    <span class="el-link--inner" @click="updateRows('down',index,index1)"><i class="el-icon-bottom"></i></span>
                                </a>
                            </div>
                        </div>
                    </div>
<!--                    <div class="el-divider el-divider&#45;&#45;horizontal"></div>-->
                </div>
            </div>
            <div class="no-question" v-if="item.list.length == 0">
                    <span>此大题还未添加试题，请点击"
                        <a class="el-link el-link--primary is-underline">
                            <span class="el-link--inner"  @click="startDialog(index,item.exerciseType)">添加试题</span>
                        </a>
                        "按钮选择试题
                    </span>
            </div>
        </div>
        <GridSelectU v-show="false" style="width: 177px;" title="选择试题" labelName="exerciseName" :btn="true" ref="gridSelectU"
                     labelValue="id" :value="userId" :limit='99' size='small' placeholder='请选择试题'
                     @getValue="getValueUser" :columns="EDUCLASSCOURSTESTPAPER_code" :searchs="EDUCLASSCOURSTESTPAPER_search" dataListUrl="/edu/exercise/findList" entityBeanName="eduExercise" queryEntityUrl="/edu/exercise/get">
        </GridSelectU>
    </div>
</template>

<script>
import GridSelectU from '@/components/gridselect/gidselect.vue';
import { EDUCLASSCOURSTESTPAPER, EDUCLASSCOURSTESTPAPER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU
    },
    data() {
        return {
            EDUCLASSCOURSTESTPAPER_code: EDUCLASSCOURSTESTPAPER,
            EDUCLASSCOURSTESTPAPER_search: EDUCLASSCOURSTESTPAPER_SEARCH,
            exerciseType: [],
            userId: '',
            index: '',
            count: 0,
        }
    },
    methods: {
        init(list){
            for (let item of list) {
                if(item.exerciseType == 1 || item.exerciseType == 2){
                    for (let item2 of item.list) {
                        let str = item2.exercise.choices.reduce((acc, items) => {
                            if (items.isAnswer === 1) {
                                return acc + (acc ? ', ' : '') + items.option;
                            }
                            return acc;
                        }, '');
                        item2.exercise.answer = str;
                        console.log(str)
                    }
                }
            }
            this.exerciseType = list;
        },
        openJx(index,index1){
            this.exerciseType[index].list[index1].isOpen = !this.exerciseType[index].list[index1].isOpen;
        },
        getValueUser(val){
            console.log(val)
            this.userId = "";
            this.$emit('sublist', this.index, val)
        },
        startDialog(index,exerciseType){
            console.log(index,exerciseType)
            this.index = index;
            this.$refs.gridSelectU.init(exerciseType);
        },
        updateRows(rows,index,index1){
            let list = this.exerciseType[index].list[index1];
            if(rows == 'up' && index1 > 0){
                let obj = this.exerciseType[index].list[index1 - 1];
                let seq = obj.seq;
                obj.seq = list.seq
                list.seq = seq;
                this.exerciseType[index].list[index1 - 1] = list;
                this.exerciseType[index].list[index1] = obj;
            }else if(rows == 'down' && index1 < this.exerciseType[index].list.length - 1){
                let obj = this.exerciseType[index].list[index1 + 1];
                let seq = obj.seq;
                obj.seq = list.seq
                list.seq = seq;
                this.exerciseType[index].list[index1 + 1] = list;
                this.exerciseType[index].list[index1] = obj;
            }else if (rows == 'delete'){
                this.count = 0;
                this.exerciseType[index].list.splice(index1, 1);
                for (let i = 0; i < index; i++) {
                    this.count += this.exerciseType[i].totalSize;
                }
                for (let i = index; i < this.exerciseType.length; i++){
                    for (let exerciseTypeElementElement of this.exerciseType[i].list) {
                        exerciseTypeElementElement.seq = ++this.count;
                    }
                }
                // for (let i = index1; i < this.exerciseType[index].list.length; i++) {
                //     this.exerciseType[index].list[i].seq = i + 1;
                // }
                this.exerciseType[index].totalSize = this.exerciseType[index].list.length;
                this.exerciseType[index].totalScore = this.exerciseType[index].totalSize * this.exerciseType[index].everyScore;
            }
            this.$emit('updateRowsIn', this.exerciseType)
            this.$forceUpdate()
        },
        editName(){
            this.$emit('editName')
        }
    }
}
</script>

<style scoped lang="scss">
.hending{
    font-size: 16px;
    padding: 10px 15px;
    line-height: 30px;
    background: #fff;
    border-bottom: 1px solid #f5f5f5;
}
.question{
    margin-bottom: 50px;
    font-size: 14px;
    border-top: 1px solid #ccc;
    padding-top: 10px;
    .testpaper-question-seq-wrap{
        float: left;
        width: 40px;
        margin-right: 10px;
        text-align: center;
        .testpaper-question-seq{
            font-size: 20px;
            color: #3a87ad;
        }
        .testpaper-question-score{
            font-size: 12px;
            color: #aaa;
            border: 1px solid #ccc;
            padding: 0 1px;
            border-radius: 5px;
            background: #f6f6f6;
            display: inline-block;
        }
    }
    .testpaper-question-stem{
        margin-bottom: 10px;
        padding-bottom: 10px;
        border-bottom: 1px dashed #ddd;
        overflow: hidden;
        zoom: 1;
    }
    .testpaper-question-choices {
        margin-left: 50px;
        padding-left: 0;
        list-style: none;
        border-bottom: 1px dashed #ddd;
        margin-bottom: 10px;
        padding-bottom: 10px;
        .testpaper-question-choice-item {
            padding: 6px 0 6px 0px;
        }
    }
    .testpaper-question-footer {
        padding-left: 50px;
        .testpaper-question-result {
            float: left;
            .color-success {
                color: #43bc60 !important;
            }
        }

        .mts {
            margin-top: 5px !important;
        }

        .pull-right {
            float: right !important;
        }
        .link-gray {
            cursor: pointer;
            color: #333 !important;
        }
        .btn {
            display: inline-block;
            margin-bottom: 0;
            font-weight: 400;
            text-align: center;
            vertical-align: middle;
            touch-action: manipulation;
            cursor: pointer;
            background-image: none;
            border: 1px solid transparent;
            white-space: nowrap;
            padding: 6px 12px;
            font-size: 14px;
            line-height: 1.42857143;
            border-radius: 4px;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }
    }
}
.testpaper-question {
    position: relative;
    margin-bottom: 50px;
    font-size: 14px;
    border-top: 1px solid #ccc;
    padding-top: 20px;
}
.well {
    background-color: #fafafa;
    border: 1px solid #f5f5f5;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
}
.mb0 {
    margin-bottom: 0 !important;
}
.well {
    min-height: 20px;
    padding: 10px;
    margin-bottom: 20px;
    background-color: #f5f5f5;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .05);
}
</style>